import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ControlValueAccessor } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';


@Component({
  selector: 'app-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['./checkbox-field.component.scss'],
  standalone: true,
  imports: [NzCheckboxModule, CommonModule, FormsModule, TranslocoDirective]
})
export class CheckboxFieldComponent {

  @Input() description: string = '';
  @Input() items: any = {

  };

  @Input() field: string = '';
  @Input() style: string = '';
  @Input() disabled: boolean = false;


  @Output() valueChange = new EventEmitter<any>();


  tickCheckbox() {
    this.items[this.field] = (this.items[this.field] === undefined || this.items[this.field] === null || this.items[this.field] === false) ? true : !this.items[this.field]
    this.valueChange.emit(this.items[this.field]);
  }

}
